import {Controller} from "stimulus"
import {Power1, TweenLite} from "gsap/all";

export default class extends Controller {

    static targets = [
    ]

    initialize(){
        if (location.hash) {
            const timeout = setTimeout(() => {
                const timeout2 = setTimeout(() => {
                    this.scrollToFromHash(document.location.hash + "-target")
                    clearTimeout(timeout2)
                }, 20)
                clearTimeout(timeout)
            }, 1)
        }
        const anchors = document.querySelectorAll('a[href^="#"]')
        this.initializeForEveryAnchors(anchors ? [...anchors] : [])
    }

    scrollToFromHash(hash, button = undefined){
        let regex = new RegExp("\#(.*)", "gi")
        let targetElement = ''

        if (hash.match("\#(.+)")) {

            hash = hash.replace(regex, "$1")

            if (document.querySelector("#" + hash)) {
                targetElement = "#" + hash;

            } else if (document.querySelector("a[name=" + hash + "]")) {
                targetElement = "a[name=" + hash + "]"
            }

            if (targetElement !== '') {

                const $element = document.querySelector(targetElement)

                if( window.scrollTo ) {
                    let offset = button ? button.dataset.hashOffset : 0
                    offset = offset ? parseInt(offset) : 0
                    window.scrollTo({top: getOffsetTop($element) - 40, left: 0, behavior: 'smooth'})
                } else {
                    this.animate($element, button, "#" + hash)
                }

                return false

            }

        }
    }

    initializeForEveryAnchors(elements) {

        elements.forEach(button => {

            button.addEventListener("click", e => {

                e.preventDefault()
                let hash = button.getAttribute("href")
                this.scrollToFromHash(hash)

            })

        })

    }

    scrollTo(e) {
        const $button = e.currentTarget;
        const $targetSection = document.querySelector($button.dataset.hashSectionSelector)
        this.animate($targetSection, $button)
    }

    animate($targetSection, $button, hash = false){
        let offset = $button.dataset.hashOffset
        offset = offset ? offset : ""
        return TweenLite.to(window, 1, {
            scrollTo: {y: $targetSection, offsetY: parseInt(offset), autoKill:false},
            ease: Power1.easeInOut,
            onComplete: () => {
                if ( hash ) {
                    window.location = hash
                }
            }
        })
    }

}